import { Injectable } from '@angular/core';
import { Action } from '@/core/util/permission-action';
import { ACTION_PERMISSION_MAP } from '@/share/constant/button-permission-action.map';

@Injectable({ providedIn: 'root' })
export class PermissionResolverService {
    resolve(action: string): Action {
        return ACTION_PERMISSION_MAP[action] ?? (action as Action);
    }
}
